import React, { useEffect, useState } from 'react';
import { ValidateButton } from './sections/ValidationSection';

// Shown only while the final validation block is out of view, so the validation is always reachable on a phone.
// Without IntersectionObserver the bar is never shown (the final block stays the way to validate).
// The bar sits in the flow right above the final block: it is hidden as soon as that block comes within
// STICKY_CLEARANCE_PX below the viewport, so it never covers the end of the practice verdict that precedes it.
export const STICKY_CLEARANCE_PX = 240;
export const STICKY_ROOT_MARGIN = `0px 0px ${STICKY_CLEARANCE_PX}px 0px`;

export const useInView = (ref, active) => {
    const [inView, setInView] = useState(true);
    useEffect(() => {
        const node = ref.current;
        if (!active || !node || typeof window === 'undefined' || typeof window.IntersectionObserver !== 'function') return undefined;
        const observer = new window.IntersectionObserver((entries) => {
            entries.forEach((entry) => setInView(entry.isIntersecting));
        }, { rootMargin: STICKY_ROOT_MARGIN });
        observer.observe(node);
        return () => observer.disconnect();
    }, [ref, active]);
    return inView;
};

const StickyValidateBar = ({ visible, countdown, pending, onValidate }) => {
    if (!visible) return null;
    return (
        <div className="hia-ack-sticky" data-testid="sticky-bar">
            <div className="hia-ack-sticky-inner">
                {countdown}
                <ValidateButton pending={pending} onValidate={onValidate} testId="validate-sticky" />
            </div>
        </div>
    );
};

export default StickyValidateBar;
